(($) => {


    $('.TechnologyLinks-picture').each(function () {
        new Vivus('js-TechnologyLinks-svg', {
            type: 'delayed',
            duration: 200
        })
    })


})(jQuery)